import { action } from 'typesafe-actions';

import { IFilterResult } from 'APIPackage/MainModule/interfaces/IFilterResult';
import { IFederalLawErvk } from 'APIPackage/CatalogsModule/interfaces/IFederalLawErvk';

import { KnmListFilterActionsEnum } from '../enums/KnmListFilterActionsEnum';
import { IKnmListFilter } from '../interfaces/IKnmListFilter';

export interface IKnmListFilterSetCurrentParams {
  current?: IKnmListFilter;
  currentId?: IFilterResult['id'];
}

export const knmListFilterInit = () => action(KnmListFilterActionsEnum.KNM_LIST_FILTER_INIT);
export const knmListFilterSetPlanNum = (planNum?: number) =>
  action(KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_PLAN_NUM, { planNum });
export const knmListFilterSetSwitcher = (value: boolean) =>
  action(KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_SWITCHER, { value });
export const knmListFilterSetCurrent = ({ current, currentId }: IKnmListFilterSetCurrentParams) =>
  action(KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_CURRENT, { current, currentId });
export const knmListFilterGetMeta = () => action(KnmListFilterActionsEnum.KNM_LIST_FILTER_GET_META);
export const knmListFilterSetMeta = (list: IFilterResult[]) =>
  action(KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_META, { list });
export const knmListFilterGetData = (id: IFilterResult['id']) =>
  action(KnmListFilterActionsEnum.KNM_LIST_FILTER_GET_DATA, { id });
export const knmListFilterSetData = (id: IFilterResult['id'], data: IKnmListFilter) =>
  action(KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_DATA, { id, data });
export const knmListFilterCreate = (data: IKnmListFilter) =>
  action(KnmListFilterActionsEnum.KNM_LIST_FILTER_CREATE, { data });
export const knmListFilterUpdate = (id: IFilterResult['id'], data: IKnmListFilter) =>
  action(KnmListFilterActionsEnum.KNM_LIST_FILTER_UPDATE, { id, data });
export const knmListFilterRemove = (id: IFilterResult['id']) =>
  action(KnmListFilterActionsEnum.KNM_LIST_FILTER_REMOVE, { id });
export const knmListFilterSetCurrentControlOrganizations = (ids: string[]) =>
  action(KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_CURRENT_CONTROL_ORGANIZATIONS, { ids });
export const knmListFilterSetCurrentFederalLaws = (federalLaws: IFederalLawErvk[]) =>
  action(KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_CURRENT_FEDERAL_LAWS, { federalLaws });
